import { render } from "./external-home.vue?vue&type=template&id=5f019764&scoped=true"
import script from "./external-home.vue?vue&type=script&lang=js"
export * from "./external-home.vue?vue&type=script&lang=js"

import "./external-home.vue?vue&type=style&index=0&id=5f019764&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f019764"]])

export default __exports__